<script>
/* eslint-disable no-undef */
import { cloneDeep } from 'lodash-es'

export default {
    name: 'DailyNav',

    props: {
        bottomNav: {
            type: Boolean,
            default: false
        },
        dataSet: {
            type: Object,
            required: true
        }
    },

    computed: {
        navDayFormat() {
            return this.dateFormatDay(this.dataSet.navDay)
        }
    },

    methods: {
        sameOrAfterStart() {
            const dayBefore = cloneDeep(this.dataSet.navDay)
            dayBefore.subtract(1, 'd').startOf('day')
            return moment(dayBefore).isSameOrAfter(this.dataSet.navDateRange.start)

        },

        sameOrBeforeEnd() {
            const dayAfter = cloneDeep(this.dataSet.navDay)
            dayAfter.add(1, 'd').startOf('day')
            return moment(dayAfter).isSameOrBefore(this.dataSet.navDateRange.end)
        },

        navigate(payload) {
            switch (payload) {
            case 'day-before':
                if ( this.sameOrAfterStart() ) {
                    this.$emit('navigate', payload)
                }
                break
            case 'day-after':
                if ( this.sameOrBeforeEnd() ) {
                    this.$emit('navigate', payload)
                }
                break
            default:
                console.error('unknown case in daily nav navigate: ', payload)
            }
            if ( this.bottomNav ) {
                this.$scrollTo(document.body)
            }
        }
    }
}
</script>

<template>
    <div class="calendar-subnav d-flex py-4">
        <div class="outer d-flex">
            <div
                class="nav-left"
                :class="{
                    'active' : sameOrAfterStart()
                }"
                @click="navigate('day-before')"
            >
                <svg class="icon icon-cal-subnav-left">
                    <use xlink:href="#cal-subnav-left" />
                </svg>
            </div>
            <div class="nav-center daily px-sm-5 text-center text-uppercase">
                {{ navDayFormat }}
            </div>
            <div
                class="nav-right"
                :class="{
                    'active' : sameOrBeforeEnd()
                }"
                @click="navigate('day-after')"
            >
                <svg class="icon icon-cal-subnav-right">
                    <use xlink:href="#cal-subnav-right" />
                </svg>
            </div>
        </div>
    </div>
</template>
